/**
 * Product page: detect when EPA / Spice Product Addons mounts into the DOM,
 * then replace variant <select> controls with radio buttons.
 */
(function () {
  var SELECTOR = '#spiceaddonsappid, .spice-spa-addon-layouts, [id^="shopify-block-"][id*="spice_addons"]';
  var VARIANT_SELECT_SELECTOR = 'select.spice-spa-addon-variant-id, select[name="spice_select_variant_id"]';
  var notified = false;

  /**
   * Replaces a <select> with radio buttons that stay in sync with the select.
   * Selecting a radio updates the select value and dispatches a change event.
   */
  function SpiceSelectToRadios(select, options) {
    if (!(select instanceof HTMLSelectElement)) {
      throw new Error('SpiceSelectToRadios expects an HTMLSelectElement');
    }

    this.select = select;
    this.options = options || {};
    this.hideSelect = this.options.hideSelect !== false;
    this.name =
      this.options.name ||
      select.id ||
      'spice-variant-radios-' + String(Math.random()).slice(2);
    this.wrapper = null;
    this._onSelectChange = this._onSelectChange.bind(this);

    this.build();
  }

  SpiceSelectToRadios.prototype.build = function () {
    if (this.select.dataset.spiceRadiosBound === 'true') return;
    this.select.dataset.spiceRadiosBound = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'apollo-spice-variant-radios';
    wrapper.setAttribute('role', 'radiogroup');
    wrapper.setAttribute(
      'aria-label',
      this.select.getAttribute('aria-label') ||
        (this.select.labels && this.select.labels[0]
          ? this.select.labels[0].textContent.trim()
          : 'Variant options')
    );

    var options = Array.prototype.slice.call(this.select.options);
    var selectedValue = this.select.value;

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      if (option.disabled && !option.value) continue;

      var optionId = this.name + '-option-' + i;
      var label = document.createElement('label');
      label.className = 'apollo-spice-variant-radios__option';
      label.setAttribute('for', optionId);

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.className = 'apollo-spice-variant-radios__input';
      radio.name = this.name;
      radio.id = optionId;
      radio.value = option.value;
      radio.checked = option.value === selectedValue || option.selected;
      radio.disabled = option.disabled;

      var text = document.createElement('span');
      text.className = 'apollo-spice-variant-radios__label';
      text.textContent = option.textContent.trim();

      label.appendChild(radio);
      label.appendChild(text);
      wrapper.appendChild(label);

      radio.addEventListener('change', this._onRadioChange.bind(this));
    }

    this.wrapper = wrapper;
    this.select.insertAdjacentElement('afterend', wrapper);

    if (this.hideSelect) {
      this.select.classList.add('apollo-spice-variant-select--hidden');
      this.select.setAttribute('aria-hidden', 'true');
      this.select.tabIndex = -1;
    }

    this.select.addEventListener('change', this._onSelectChange);
  };

  SpiceSelectToRadios.prototype._onRadioChange = function (event) {
    var radio = event.target;
    if (!radio || !radio.checked) return;

    if (this.select.value !== radio.value) {
      this.select.value = radio.value;
    }

    // Native change so Spice / SPA handlers (onchange, listeners) run
    var changeEvent;
    try {
      changeEvent = new Event('change', { bubbles: true });
    } catch (err) {
      changeEvent = document.createEvent('HTMLEvents');
      changeEvent.initEvent('change', true, false);
    }

    this.select.dispatchEvent(changeEvent);
  };

  SpiceSelectToRadios.prototype._onSelectChange = function () {
    if (!this.wrapper) return;

    var value = this.select.value;
    var radios = this.wrapper.querySelectorAll(
      '.apollo-spice-variant-radios__input'
    );

    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = radios[i].value === value;
    }
  };

  SpiceSelectToRadios.prototype.destroy = function () {
    this.select.removeEventListener('change', this._onSelectChange);
    this.select.classList.remove('apollo-spice-variant-select--hidden');
    this.select.removeAttribute('aria-hidden');
    this.select.tabIndex = 0;
    delete this.select.dataset.spiceRadiosBound;

    if (this.wrapper && this.wrapper.parentNode) {
      this.wrapper.parentNode.removeChild(this.wrapper);
    }

    this.wrapper = null;
  };

  SpiceSelectToRadios.initIn = function (root) {
    if (!root || !root.querySelectorAll) return [];

    var selects = root.querySelectorAll(VARIANT_SELECT_SELECTOR);
    var instances = [];

    for (var i = 0; i < selects.length; i++) {
      if (selects[i].dataset.spiceRadiosBound === 'true') continue;
      instances.push(new SpiceSelectToRadios(selects[i]));
    }

    return instances;
  };

  window.SpiceSelectToRadios = SpiceSelectToRadios;

  /**
   * When a group has only one .spice-spa-addon-product-item,
   * marks the parent .spice-addon-group-dropdownBox with one-item-only.
   */
  function SpiceOneItemOnly(root) {
    this.root = root || document;
    this.marked = [];
    this.apply();
  }

  SpiceOneItemOnly.prototype._directProductItems = function (parent) {
    var items = [];
    if (!parent || !parent.children) return items;

    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];
      if (
        child.classList &&
        child.classList.contains('spice-spa-addon-product-item')
      ) {
        items.push(child);
      }
    }

    return items;
  };

  SpiceOneItemOnly.prototype._findDropdownBox = function (node) {
    var current = node;
    while (current && current !== this.root && current !== document.documentElement) {
      if (
        current.classList &&
        current.classList.contains('spice-addon-group-dropdownBox')
      ) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  };

  SpiceOneItemOnly.prototype._collectGroupContainers = function () {
    var items = this.root.querySelectorAll
      ? this.root.querySelectorAll('.spice-spa-addon-product-item')
      : [];
    var containers = [];
    var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

    for (var i = 0; i < items.length; i++) {
      var parent = items[i].parentElement;
      if (!parent) continue;

      if (seen) {
        if (seen.has(parent)) continue;
        seen.add(parent);
      } else if (containers.indexOf(parent) !== -1) {
        continue;
      }

      containers.push(parent);
    }

    return containers;
  };

  SpiceOneItemOnly.prototype.apply = function () {
    this.marked = [];
    var containers = this._collectGroupContainers();

    for (var i = 0; i < containers.length; i++) {
      var items = this._directProductItems(containers[i]);
      var dropdownBox = this._findDropdownBox(containers[i]);

      if (!dropdownBox) continue;

      if (items.length === 1) {
        dropdownBox.classList.add('spice-addon-group-oneitemBox');
        dropdownBox.classList.remove('spice-addon-group-dropdownBox');
        this.marked.push(dropdownBox);
      } else {
        dropdownBox.classList.remove('spice-addon-group-oneitemBox');
      }
    }

    return this.marked;
  };

  SpiceOneItemOnly.prototype.destroy = function () {
    for (var i = 0; i < this.marked.length; i++) {
      this.marked[i].classList.remove('spice-addon-group-oneitemBox');
    }
    this.marked = [];
  };

  SpiceOneItemOnly.initIn = function (root) {
    return new SpiceOneItemOnly(root || document);
  };

  window.SpiceOneItemOnly = SpiceOneItemOnly;

  function getSpiceMount(node) {
    if (!node) return null;
    if (node.id === 'spiceaddonsappid') return node;
    if (node.classList && node.classList.contains('spice-spa-addon-layouts')) {
      return node;
    }
    if (node.querySelector) {
      return (
        node.querySelector('#spiceaddonsappid') ||
        node.querySelector('.spice-spa-addon-layouts') ||
        null
      );
    }
    return null;
  }

  /**
   * App shell can appear before items are injected.
   * Wait until at least one product item exists.
   */
  function hasSpiceContent(root) {
    if (!root || !root.querySelector) return false;
    return !!root.querySelector('.spice-spa-addon-product-item');
  }

  function isSpiceReady(root) {
    var mount = getSpiceMount(root) || (hasSpiceContent(root) ? root : null);
    return !!(mount && hasSpiceContent(mount));
  }

  function onSpiceAddonsReady(node) {
    if (notified) return;

    var mount =
      getSpiceMount(node) ||
      document.getElementById('spiceaddonsappid') ||
      document.querySelector('.spice-spa-addon-layouts') ||
      node;

    if (!hasSpiceContent(mount)) return;

    notified = true;

    console.log('[Apollo][Spice Addons] App block loaded', {
      element: mount,
      productItems: mount.querySelectorAll('.spice-spa-addon-product-item').length,
      groups: mount.querySelectorAll('.spice-addon-group-dropdownBox').length
    });

    var radioInstances = SpiceSelectToRadios.initIn(mount);
    console.log(
      '[Apollo][Spice Addons] Variant selects converted to radios:',
      radioInstances.length
    );

    var oneItemInstance = SpiceOneItemOnly.initIn(mount);
    console.log(
      '[Apollo][Spice Addons] Single-item groups marked:',
      oneItemInstance.marked.length
    );

    document.dispatchEvent(
      new CustomEvent('apollo:spice-addons-ready', {
        detail: {
          element: mount,
          radioInstances: radioInstances,
          oneItemInstance: oneItemInstance
        }
      })
    );

    if (observer) observer.disconnect();
  }

  function checkExisting() {
    var existing =
      document.getElementById('spiceaddonsappid') ||
      document.querySelector('.spice-spa-addon-layouts') ||
      document.querySelector(SELECTOR);

    if (existing && isSpiceReady(existing)) {
      onSpiceAddonsReady(existing);
      return true;
    }
    return false;
  }

  var observer = new MutationObserver(function () {
    if (notified) return;
    if (checkExisting()) return;
  });

  function start() {
    if (checkExisting()) return;

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      if (!notified && observer) {
        observer.disconnect();
        console.log('[Apollo][Spice Addons] App block not detected within timeout');
      }
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
